import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { AssetTableComponent } from "../asset-table/asset-table.component";
import { AgGridModule } from "ag-grid-angular";
import { FormsModule } from "@angular/forms";
import { AssetViewerComponent } from "../asset-viewer/asset-viewer.component";
import { QueryLayersService } from "../services/query-layers.service";
import { AssetDetailComponent } from "../asset-viewer/asset-detail/asset-detail.component";
import { TasksComponent } from "../asset-viewer/asset-detail/tasks/tasks.component";
import { AssessmentComponent } from "../asset-viewer/asset-detail/assessment/assessment.component";
import { Globals } from "./globals";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CreateTaskComponent } from "../create-task/create-task.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MatTabsModule } from "@angular/material/tabs";
// import { ImageViewerModule as ng2ImageViewerModule } from 'ng2-image-viewer'; // Added by Abhilash Jira Id:-40 on 9/28/2021
import { CustomTooltip } from "../asset-table/customTooltip.component"; // Added by Abhilash Jira Id:-40 on 9/28/2021
import { SharedModule } from "./shared.module";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { PdfViewerModule } from "ng2-pdf-viewer";
@NgModule({
    imports: [
        BrowserModule,  //only imported here
        PdfViewerModule,
        FormsModule,
        MatIconModule,
        FontAwesomeModule,
        AgGridModule,
        MatDatepickerModule,
        BrowserAnimationsModule,
        MatToolbarModule,  //only imported here
        MatButtonModule,
        MatSelectModule,
        MatInputModule,
        MatAutocompleteModule,
        MatButtonToggleModule,
        MatSidenavModule,
        MatListModule,
        SharedModule,
        MatFormFieldModule,
        MatTabsModule,
        MatSlideToggleModule,  //only imported here
        MatProgressSpinnerModule,
        TranslateModule,
        DragDropModule,
        NgSelectModule,
        AssetTableComponent, AssetViewerComponent, AssetDetailComponent, CreateTaskComponent, TasksComponent, AssessmentComponent, CustomTooltip
    ],
    exports: [AssetTableComponent, AssetViewerComponent, AssetDetailComponent, CreateTaskComponent],
    providers: [QueryLayersService, Globals]
})
export class SelectModule {
  static forRoot(): ModuleWithProviders<SelectModule> {
    return { ngModule: SelectModule, providers: [] };
  }
}

//8/14/26 need this module???  how to accomplish same without?  If not included in main.ts, login screen doesn't even show up.